const updates = [
  {
    date: '07-31',
    title: '《长安十二时辰》精编版全48集高清上线',
    tag: '新片上线',
    tagColor: 'bg-primary-100 text-primary-700',
  },
  {
    date: '07-30',
    title: '系统全面升级：4K超清专区正式开放，百部经典影片已适配',
    tag: '平台公告',
    tagColor: 'bg-accent-100 text-accent-700',
  },
  {
    date: '07-29',
    title: '《向往的生活》第八季第10期温情上线',
    tag: '综艺更新',
    tagColor: 'bg-green-100 text-green-700',
  },
  {
    date: '07-28',
    title: '新增弹幕功能测试版，热门剧集已开启用户弹幕互动',
    tag: '功能更新',
    tagColor: 'bg-secondary-100 text-secondary-700',
  },
  {
    date: '07-27',
    title: '暑期档特别策划：百部经典动画限时重温专题上线',
    tag: '专题活动',
    tagColor: 'bg-orange-100 text-orange-700',
  },
  {
    date: '07-26',
    title: '用户观影报告功能上线：查看你的年度观影数据',
    tag: '功能更新',
    tagColor: 'bg-secondary-100 text-secondary-700',
  },
  {
    date: '07-25',
    title: '《暗夜追踪》第三季播放量突破50亿，创平台新纪录',
    tag: '数据快报',
    tagColor: 'bg-accent-100 text-accent-700',
  },
];

export default function Updates() {
  return (
    <section id="updates" className="py-16 md:py-24 bg-background-50">
      <div className="max-w-3xl mx-auto px-4 md:px-6">
        <div className="text-center mb-10 md:mb-14">
          <span className="inline-block px-4 py-1.5 rounded-full bg-primary-100 text-primary-700 text-xs font-medium mb-4">
            实时动态
          </span>
          <h2 className="text-2xl md:text-3xl lg:text-4xl font-heading font-bold text-foreground-950">
            最新快讯
          </h2>
          <p className="mt-2 text-foreground-500 text-sm md:text-base">
            丫丫影院平台动态与内容更新一手掌握
          </p>
        </div>

        <div className="relative">
          <div className="absolute left-[19px] top-2 bottom-2 w-px bg-background-300 hidden md:block"></div>

          <div className="space-y-0">
            {updates.map((item, idx) => (
              <div key={idx} className="flex gap-5 md:gap-6 py-5 md:py-4">
                <div className="hidden md:flex flex-col items-center shrink-0 pt-1">
                  <div className="w-[10px] h-[10px] rounded-full bg-primary-500 ring-4 ring-primary-100"></div>
                </div>

                <div className="flex-1 bg-white rounded-2xl p-5 md:p-6 hover:bg-primary-50/20 transition-colors duration-200">
                  <div className="flex flex-wrap items-center gap-3 mb-2">
                    <span className="text-xs font-mono text-foreground-400 md:hidden">{item.date}</span>
                    <span className={`px-2.5 py-0.5 rounded-full text-xs font-medium ${item.tagColor}`}>
                      {item.tag}
                    </span>
                    <span className="hidden md:inline text-xs font-mono text-foreground-400">{item.date}</span>
                  </div>
                  <p className="text-sm md:text-base text-foreground-800 leading-relaxed">
                    {item.title}
                  </p>
                </div>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}